import {createAsyncAction} from 'typesafe-actions';

// import { CreateRequest } from '../../../api/medAppApi';
// import { Model, ModelName} from '../../../models';

export const getContrctorDashboardAction = createAsyncAction(
    'MED_APP/CONTRACTOR/GET_DASHBOARD/REQUEST',
    'MED_APP/CONTRACTOR/GET_DASHBOARD/SUCCESS',
    'MED_APP/CONTRACTOR/GET_DASHBOARD/FAIL',
)<never,  {
    Delivered: number;
    Rejected: number;
    Pending: number;
    Accepted: number;
  }, 
  any>();


